"use client";

import Image from "next/image";

export default function GrowSection() {
  return (
    <section className="w-full flex justify-center items-center py-4 sm:py-6 lg:py-8 px-4">
      <div className="max-w-6xl w-full bg-[var(--primary-bg)] rounded-3xl flex flex-col md:flex-row items-center p-6 md:p-10 lg:p-12 gap-8 lg:gap-16 shadow-lg">
        {/* Left Content */}
        <div className="flex-1 flex flex-col justify-center items-center md:items-start text-center md:text-left">
          <h1 className="text-3xl sm:text-4xl md:text-4xl lg:text-5xl font-[BOOWIE] font-bold leading-snug">
            GROW YOURSELF <br />
            & OUR NATION <br />
            WITH GITARTHA
          </h1>
        </div>

        {/* Right Content */}
        <div className="flex-1 relative flex justify-center">
          {/* Background Logo */}
          <div
            className="
              absolute
              -left-6 sm:-left-4 md:-left-10
              -top-4 sm:top-2 md:top-6
              w-48 sm:w-20 md:w-28
              opacity-20 sm:opacity-60
              rotate-[-18deg]
              pointer-events-none
              transition-all
              z-10
            "
          >
            <Image
              src="/Artha.png"
              alt="Gitartha Logo"
              width={600}
              height={400}
              className="w-full h-auto drop-shadow-lg"
              priority
            />
          </div>

          {/* Founder */}
          <Image
            src="/Founder.png"
            alt="Founder"
            width={800}
            height={600}
            className="relative z-20 w-full max-w-xs sm:max-w-sm md:max-w-md rounded-3xl object-contain"
          />
        </div>
      </div>
    </section>
  );
}